import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  MenuItem,
  Select,
  FormControl,
  Checkbox,
} from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";

function SelectField({ displayName, fieldRef, options, editable = false }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [enableEditable, setEnableEditable] = useState(false);

  useEffect(() => {
    if (selectedOption === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [selectedOption]);

  return (
    <MDBox mt={1}>
      <MDBox>
        <MDBox ml={0.5}>
          <MDTypography variant="h6" fontSize={14} fontWeight="light">
            {displayName}
          </MDTypography>
        </MDBox>
        <FormControl sx={{ minWidth: 120, width: "100%" }}>
          <Select
            sx={{ padding: "12px", paddingLeft: "3px" }}
            onChange={(e) => {
              if (editable === true) {
                setEnableEditable(false);
              }
              setSelectedOption(e.target.value);
            }}
            value={selectedOption}
          >
            {editable === true && (
              <MenuItem value={null}>Select an option</MenuItem>
            )}
            {options.map((option) => (
              <MenuItem value={option.value}>{option.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </MDBox>
      {editable === true && (
        <MDBox mt={2}>
          <MDBox display="flex" alignItems="center" ml={-1}>
            <Checkbox
              checked={enableEditable}
              onChange={(e) => {
                setSelectedOption(null);
                setEnableEditable(e.target.checked);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="text"
              sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            >
              &nbsp;&nbsp;Enter your own {displayName}
            </MDTypography>
          </MDBox>
          {enableEditable === true && (
            <MDBox mt={2}>
              <MDInput
                placeholder={`Enter your ${displayName}`}
                margin="dense"
                label={displayName}
                type="text"
                fullWidth
                variant="outlined"
                value={selectedOption}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
            </MDBox>
          )}
        </MDBox>
      )}
      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={selectedOption}
      />
    </MDBox>
  );
}

// Typechecking props of the Transaction
SelectField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.any),
};

SelectField.defaultProps = {
  options: null,
  editable: false,
};
export default SelectField;
